var path = '/app/pages/account/settings/password/account.settings.password.html';
var html = "<div class=p-0> <div class=px-3> <div class=row> <div class=col> <dynamic-heading text=ctrl.heading></dynamic-heading> <hr> <div uib-alert ng-if=ctrl.Alerts.local.msg ng-class=\"'p-4 my-4 alert-' + (ctrl.Alerts.local.type || 'info')\"> {{ ctrl.Alerts.local.msg }}</div> <dynamic-form ng-if=ctrl.formTemplate template=ctrl.formTemplate ng-model=ctrl.formTemplate.model> </dynamic-form> </div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/account/settings/password/account.settings.password.html
// module id = 540
// module chunks = 0